import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import CustomisedButton from '../../components/button/button';
import CustomisedCardBullet from '../../components/card/cardBullet';
import { IShellConfig } from '../../models/IShellConfig';
import { IGetKycVideoHintsResponse } from '../../models/kyc.model';
import { changeRouteType, getpervInnerState } from '../../redux/handleBackBtn/handleBackBtnSlice';
import { setHeaderTitle } from '../../redux/headerTitle/headerTitleSlice';
import { RootState } from '../../redux/store';
import { getVideoText } from '../../redux/video/videoSlice';
import { GetKycVideoHints } from '../../services/kyc.service';
import { IVideoAuthorization } from './IVideoAuthorization';
import VideoHintsSkeleton from './videoHintsSkeleton';

const VideoHints = ({ setState, referenceKey }: IVideoAuthorization) => {
    const [jsonFile, setJsonFile] = useState<IShellConfig>();
    const [hints, setHints] = useState<IGetKycVideoHintsResponse>();
    const dispatch = useDispatch();
    const randomKeyForDispatch = Math.random();
    const mode = useSelector((state: RootState) => state.theme) as 'light' | 'dark';
    // get app config
    useEffect(() => {
        dispatch(setHeaderTitle({ header: 'احراز هویت ویدیوئی', color: 'var(--header-color)', parentRoute: 'kyc' }));

        fetch('/setting/shellConfig.json')
            .then((response) => response.json())
            .then((data) => {
                setJsonFile(data);
            });


        GetKycVideoHintsMutate({
            referenceKey: referenceKey
        });
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));
    }, []);

    // get hints from api
    const { mutate: GetKycVideoHintsMutate, isLoading } = useMutation(
        GetKycVideoHints,
        {
            onSuccess: (data: IGetKycVideoHintsResponse) => {
                if (data) {
                    setHints(data);
                    dispatch(getVideoText(data.textContent));
                }
            },

            onError: () => { },
        }
    );


    const themeColors = jsonFile?.[mode];
    const handleContinue = () => {
        dispatch(changeRouteType({ routeType: 'child' }));
        setState!('captureVideo');
    }
    if (isLoading) {
        return <VideoHintsSkeleton />;
    }
    return (
        <Grid
            container
            flexDirection={'column'}
            sx={{
                justifyContent: 'space-between',
                alignItems: 'center',
                height: '100%',
                paddingTop: "10px",
                paddingInline: "20px"
            }}
        >
            <Grid
                item
                sx={{
                    width: '100%',
                    height: "90%"
                }}
            >
                <Grid container flexDirection={'column'} alignItems={'center'} height={"100%"}>
                    <Grid item height={"40%"} sx={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                        <Typography
                            sx={{
                                color: `${themeColors?.primaryColorLight900}`,
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                textAlign: 'center',
                            }}
                        >
                            راهنمای ضبط صحیح ویدیو
                        </Typography>
                        <Box sx={{ marginY: '1rem' }}>
                            <img
                                src="/images/success-video.png"
                                alt="تصویر گوشی موبایل"
                                width={180}
                                height={150}
                            />
                        </Box>
                    </Grid>
                    <Grid item height={{ xs: "58%", sm: "auto" }} overflow={"auto"}>
                        <Grid container sx={{ display: "flex", justifyContent: "start" }} gap={0} height={"100%"}>
                            {hints?.hints?.map((hint, index: number) => (
                                <Grid xs={12} item sx={{ width: '100%', height: "fit-content" }}>
                                    <CustomisedCardBullet
                                        firstTitle={hint}
                                        key={index}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Box
                sx={{ height: "10%", width: "100%" }}
            >
                <CustomisedButton
                    title="ادامه"
                    disable={false}
                    onClick={handleContinue}
                    type="button"
                />
            </Box>
        </Grid>
    );
};

export default VideoHints;
